import { DateTime } from 'luxon';

const DefaultSwipeHistoryRetentionInHours = 12;

const removeExpiredSwipes = (swipes, retentionTimeHours) =>
    (swipes || []).filter(s => {
        const swipeDate = DateTime.fromISO(s.swipeTime);
        const dateDiff = swipeDate.diffNow().as('hours');
        return Math.abs(dateDiff) < retentionTimeHours;
    });

export const activeSwipes = state => {
    const { config, swipes } = state;

    return removeExpiredSwipes(swipes.swipes, config.swipeHistoryValidityInHours || DefaultSwipeHistoryRetentionInHours);
};